const EdlinkBaseHandler = require('./EdlinkBaseHandler')

module.exports = class SchoologyHandler extends EdlinkBaseHandler {
  constructor () {
    super('schoology')
  }
}
